import { Link, useLocation } from 'react-router-dom';

// Navigation interne du studio (spec 73 — structure principale ZSTUDIO).
export const ZSTUDIO_SECTIONS: { path: string; label: string; icon: string; exact?: boolean }[] = [
  { path: '/dashboard/zstudio', label: 'Accueil', icon: 'ri-home-4-line', exact: true },
  { path: '/dashboard/zstudio/wizard', label: 'Créer', icon: 'ri-magic-line' },
  { path: '/dashboard/zstudio/tryon', label: 'Try-on', icon: 'ri-user-star-line' },
  { path: '/dashboard/zstudio/lookbook', label: 'Lookbook', icon: 'ri-book-open-line' },
  { path: '/dashboard/zstudio/edit', label: 'Édition IA', icon: 'ri-equalizer-2-line' },
  { path: '/dashboard/zstudio/campaigns', label: 'Campagnes', icon: 'ri-rocket-line' },
  { path: '/dashboard/zstudio/projects', label: 'Projets', icon: 'ri-folders-line' },
  { path: '/dashboard/zstudio/qr', label: 'QR produit', icon: 'ri-qr-code-line' },
  { path: '/dashboard/zstudio/creations', label: 'Mes créations', icon: 'ri-archive-2-line' },
  { path: '/dashboard/zstudio/history', label: 'Historique', icon: 'ri-history-line' },
  { path: '/dashboard/zstudio/assistant', label: 'ZStudio AI', icon: 'ri-robot-2-line' },
];

export default function ZStudioNav() {
  const { pathname } = useLocation();

  return (
    <nav className="mb-5 -mx-4 md:mx-0 overflow-x-auto">
      <div className="flex items-center gap-1 px-4 md:px-0 w-max md:w-auto">
        {ZSTUDIO_SECTIONS.map((s) => {
          const active = s.exact ? pathname === s.path : pathname.startsWith(s.path);
          return (
            <Link
              key={s.path}
              to={s.path}
              className={`flex items-center gap-1.5 px-3 py-2 rounded-full text-xs font-medium whitespace-nowrap transition-colors cursor-pointer ${
                active
                  ? 'bg-primary-500 text-background-50'
                  : 'text-foreground-600 hover:bg-background-100'
              }`}
            >
              <i className={s.icon}></i>
              {s.label}
            </Link>
          );
        })}
      </div>
    </nav>
  );
}